import React, { useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';
import { PortalOverlay } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './CreateUpdateItem.css';
import Utils from "./Utils.js";
import LoadingView from "../../views/LoadingView.js";
import { AttributeValueEditorFormFactory } from "../forms/Factory.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.imagine.view.UpdateItem');
export default function UpdateItem(props) {
  const {
    show,
    onClose,
    target,
    delegate,
    relationship
  } = props;
  const {
    blueprint
  } = relationship;
  let closeLoading;
  const isMobile = useMediaQuery({
    query: '(max-width: 430px)'
  });
  const onSuccess = useCallback(res => {
    closeLoading?.();
    onClose?.();
    Utils.handleFormResult(res, {
      delegate,
      blueprint,
      relationship,
      onClose,
      type: 'update',
      target
    });
  }, [blueprint, delegate, relationship, target, onClose, closeLoading]);
  const onError = useCallback(err => {
    closeLoading?.();
    Utils.handleFormError(err, {
      delegate,
      blueprint,
      relationship,
      type: 'update',
      onClose,
      target: {
        ...target,
        data: {
          ...target.data,
          data: {
            ...target.data?.data
          }
        }
      }
    });
  }, [blueprint, delegate, relationship, target, onClose, closeLoading]);
  const onOkay = useCallback(() => {
    closeLoading = LoadingView.showDialog(t('loadingDialog', {
      blueprintName: blueprint.name
    }));
  }, []);
  const attributes = Utils.getAttributes(target.type, 'update');
  const EditComponent = AttributeValueEditorFormFactory.create(`${target?.type}.update`, {
    target,
    attributes,
    onSuccess,
    onError,
    onOkay,
    onCancel: onClose,
    title: t('title', {
      blueprintName: blueprint.name
    }),
    icon: blueprint.getIcon('updateDialogIcon') || blueprint.getIcon('screenIcon'),
    context: {
      clientProps: {
        ...props
      },
      usage: 'form'
    }
  });
  return /*#__PURE__*/_jsx(PortalOverlay, {
    position: isMobile ? 'full' : 'center',
    show: show,
    closeOnEscape: false,
    closeOnDocumentClick: false,
    onClose: onClose,
    targetId: "moltenPortalRoot",
    children: /*#__PURE__*/_jsx("div", {
      className: S.container,
      children: EditComponent
    })
  });
}